(function () {
  'use strict';

  var MARKER = 'instagram.com/reel/';
  var REEL_SOURCE =
    'https?:\\/\\/(?:www\\.)?instagram\\.com\\/reel\\/[A-Za-z0-9_-]+\\/?(?:\\?[^\\s<"]*)?';

  var ARTICLE_SELECTOR = '.article-content.halo-text-format';
  var STYLE_ID = 'pramogh-instagram-reel-css';

  /* Same fixed box as the section (blog-insta.liquid): one size at every
     breakpoint, only the margin differs on mobile. */
  var CSS =
    '.pramogh-instagram-reel-embed{' +
      'display:block!important;position:relative!important;' +
      'width:100%!important;max-width:540px!important;' +
      'height:680px!important;min-height:680px!important;max-height:680px!important;' +
      'margin:32px auto!important;padding:0!important;' +
      'background:#fafafa!important;overflow:hidden!important;' +
      'contain:strict!important;overflow-anchor:none!important;' +
      'box-sizing:border-box!important;border-radius:20px!important;' +
    '}' +
    '.pramogh-instagram-reel-embed .instagram-media,' +
    '.pramogh-instagram-reel-embed iframe{' +
      'position:absolute!important;inset:0!important;display:block!important;' +
      'width:100%!important;height:100%!important;' +
      'min-width:0!important;min-height:0!important;' +
      'max-width:none!important;max-height:none!important;' +
      'margin:0!important;padding:0!important;border:0!important;' +
      'box-sizing:border-box!important;' +
    '}' +
    '.pramogh-instagram-click-zone{' +
      'position:absolute!important;inset:0!important;z-index:20!important;' +
      'display:block!important;background:transparent!important;' +
      'border:0!important;outline:0!important;text-decoration:none!important;' +
      '-webkit-tap-highlight-color:transparent;' +
    '}' +
    '@media(max-width:749px){' +
      '.pramogh-instagram-reel-embed{margin:24px auto!important;border-radius:16px!important;}' +
    '}';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    /* Must be in the DOM BEFORE any wrapper is inserted. */
    document.head.appendChild(style);
  }

  function createEmbed(reelUrl) {
    var wrapper = document.createElement('div');
    wrapper.className = 'pramogh-instagram-reel-embed';
    wrapper.dataset.reelUrl = reelUrl;

    var blockquote = document.createElement('blockquote');
    blockquote.className = 'instagram-media';
    blockquote.setAttribute('data-instgrm-permalink', reelUrl);
    blockquote.setAttribute('data-instgrm-version', '14');
    blockquote.setAttribute('aria-label', 'Instagram Reel');

    var zone = document.createElement('a');
    zone.className = 'pramogh-instagram-click-zone';
    zone.href = reelUrl;
    zone.target = '_blank';
    zone.rel = 'noopener noreferrer';
    zone.setAttribute('aria-label', 'Open this Reel on Instagram');

    wrapper.appendChild(blockquote);
    wrapper.appendChild(zone);
    return wrapper;
  }

  function replaceTextNode(textNode, wrappers) {
    var text = textNode.nodeValue;
    var re = new RegExp(REEL_SOURCE, 'gi');
    var frag = document.createDocumentFragment();
    var last = 0;
    var found = false;
    var hasOtherText = false;
    var m;

    function pushText(str) {
      if (!str) return;
      if (str.trim()) hasOtherText = true;
      frag.appendChild(document.createTextNode(str));
    }

    while ((m = re.exec(text))) {
      found = true;
      pushText(text.slice(last, m.index));
      var embed = createEmbed(m[0]);
      frag.appendChild(embed);
      wrappers.push(embed);
      last = m.index + m[0].length;
    }

    if (!found) return;
    pushText(text.slice(last));

    var parent = textNode.parentNode;
    if (
      parent &&
      parent.tagName === 'P' &&
      parent.childNodes.length === 1 &&
      !hasOtherText &&
      parent.parentNode
    ) {
      parent.parentNode.replaceChild(frag, parent);
    } else {
      parent.replaceChild(frag, textNode);
    }
  }

  function convertReels() {
    var wrappers = [];
    var articles = document.querySelectorAll(ARTICLE_SELECTOR);

    Array.prototype.forEach.call(articles, function (article) {
      if (article.dataset.pramoghInstagramProcessed === 'true') return;
      if (article.textContent.indexOf(MARKER) === -1) return;

      article.dataset.pramoghInstagramProcessed = 'true';

      var walker = document.createTreeWalker(article, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          if (node.nodeValue.indexOf(MARKER) === -1) return NodeFilter.FILTER_REJECT;
          var parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;
          var tag = parent.tagName;
          if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'A' || tag === 'NOSCRIPT') {
            return NodeFilter.FILTER_REJECT;
          }
          if (parent.closest('.instagram-media,.pramogh-instagram-reel-embed')) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      var nodes = [];
      var n;
      while ((n = walker.nextNode())) nodes.push(n);
      nodes.forEach(function (node) { replaceTextNode(node, wrappers); });
    });

    return wrappers;
  }

  /* Shared with blog-insta.liquid: a single embed.js request per page. */
  function loadInstagramScript() {
    if (window.pramoghLoadInstagram) { window.pramoghLoadInstagram(); return; }

    function processAll() {
      if (!window.instgrm || !window.instgrm.Embeds) return;
      try { window.instgrm.Embeds.process(); } catch (e) {}
    }

    if (window.instgrm && window.instgrm.Embeds) { processAll(); return; }
    if (window.__pramoghInstgrmLoading) return;
    window.__pramoghInstgrmLoading = true;

    var existing = document.querySelector('script[src*="instagram.com/embed.js"]');
    if (existing) {
      existing.addEventListener('load', processAll, { once: true });
      return;
    }

    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.instagram.com/embed.js';
    s.onload = processAll;
    s.onerror = function () { window.__pramoghInstgrmLoading = false; };
    document.head.appendChild(s);
  }

  function setupLazyLoading(wrappers) {
    if (!('IntersectionObserver' in window)) {
      loadInstagramScript();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            observer.disconnect();
            loadInstagramScript();
            return;
          }
        }
      },
      { rootMargin: '600px 0px', threshold: 0 }
    );

    wrappers.forEach(function (w) { observer.observe(w); });
  }

  function init() {
    var articles = document.querySelectorAll(ARTICLE_SELECTOR);
    var hasReel = false;

    Array.prototype.forEach.call(articles, function (article) {
      if (article.textContent.indexOf(MARKER) !== -1) hasReel = true;
    });

    /* No reel on this page: no style injected, no work, no network. */
    if (!hasReel) return;

    addStyles();
    var wrappers = convertReels();
    if (wrappers.length) setupLazyLoading(wrappers);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();